import { LitElement, css, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { resolveRouterPath } from '../router';
import { styles as notesListStyles } from '../styles/notes-list';
import { styles as sharedStyles } from '../styles/shared-styles';
import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en'

import '@shoelace-style/shoelace/dist/components/button/button.js';
import { NoteItem } from '../modules/note';
@customElement('app-notes-list')
export class AppNotesList extends LitElement {
  @property({ type: String }) title = 'Note.md';
  @property({ type: Boolean}) enableBack: boolean = false;
  @property({ type: Array }) notes: Array<any> = [];
  @property({ type: Object }) activeNote: NoteItem;

  static styles = [
    sharedStyles,
    notesListStyles
  ]


  constructor() {
    super();

    TimeAgo.addDefaultLocale(en);

    this.timeAgo = new TimeAgo('en-US');

  }

  async loadActiveNote(id: number) {
    let event = new CustomEvent('events', {
      bubbles: true,
      composed: true,
      detail: {
        action: 'active-note',
        id: id
      }
    });

    this.dispatchEvent(event);
  }



  render() {
    return html`
      <aside class="notes-list">
        <ul>
          <li>
            <h4>Notes</h4>
          </li>
          ${this.notes.map(i => html`<li class="${i.id ==  this.activeNote?.id ? 'active' : ''}">
            <a @click="${() => this.loadActiveNote(i.id)}">
              <p>${i.title}</p>
              <p><small>Last edited ${this.timeAgo.format((new Date(i.last_updated)))}</small></p>
            </a>
          </li>`)}
        </ul>
      </aside>
    `;
  }
}
